import {
  AgxRow,
  AgxColumn,
  AgxBodyText,
  Images,
  StaffUploadedDocument,
  SigningMethod,
  AgxBadge,
  AgxBadgeType,
} from '@urbanx/agx-ui-components'
import { AuthContext } from '@urbanx/agx.auth.client'
import { useContext } from 'react'
import { formatFileSize } from 'utils/formatFileSize'
import { openFileInNewTab } from 'utils/openInNewTab'

interface Props {
  document: StaffUploadedDocument
}
const DocumentRow = (props: Props) => {
  const { document } = props
  const { getAuthToken } = useContext(AuthContext)

  return (
    <AgxRow key={document.documentId}>
      <AgxColumn extraClasses="file-document">
        <div
          className="file-document-container"
          onClick={() => openFileInNewTab(getAuthToken, document?.containerFilePath)}
        >
          <Images.FileTextOutline className="file-document-leftIcon" />
          <AgxBodyText medium extraClasses="file-document-body">
            <span className="file-document-name" title={document.fileName}>
              {document.fileName}
            </span>
          </AgxBodyText>
          <AgxBodyText medium extraClasses="file-document-body">
            <span className="file-document-size">
              {formatFileSize(document.fileSizeInBytes)}
            </span>
          </AgxBodyText>
          {document.signingMethod && (
            <AgxBadge
              dataTestId={`document-${document.containerFilePath}-${document.signingMethod}`}
              type={AgxBadgeType.Primary}
              small
              border
              text={
                document.signingMethod === SigningMethod.Docusign
                  ? 'Signed via Docusign'
                  : 'Signed by Agent'
              }
            />
          )}

          <Images.Download className="file-document-download" />
        </div>
      </AgxColumn>

      <AgxColumn extraClasses="file-document-date">
        <AgxBodyText>
          <span>
            {document.dateUploaded
              ? new Date(document.dateUploaded).toLocaleString('en-AU')
              : ''}
          </span>
        </AgxBodyText>
      </AgxColumn>
    </AgxRow>
  )
}

export default DocumentRow
